import { CalendarEvent } from 'angular-calendar';
import { Subscription } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LeadAssessmentService } from '@leads/shared/services/lead-assessment/lead-assessment.service';
import { NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { OrganisationUserAccessLevel } from '@organisations/models/organisation-user';
import { OrganisationSelectedService } from '@organisations/services/organisation-selected/organisation-selected.service';
import { CalendarOffcanvasComponent } from '@schedule/lib/components/calendar-offcanvas/calendar-offcanvas.component';
import { ScheduledEventCalendarEventOffcanvas } from '@schedule/lib/models/calendar-event-offcanvas';
import { ScheduledEvent } from '@schedule/models/calendar/calendar.model';
import { CalendarService } from '@schedule/services/calendar/calendar.service';
import { ModalService } from '@shared/services/modal/modal.service';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';

@Injectable({
	providedIn: 'root',
})
export class CalendarEventOffcanvasService {
	private router = inject(Router);
	private calendarService = inject(CalendarService);
	private offcanvasService = inject(OffcanvasService);
	private leadAssessmentService = inject(LeadAssessmentService);
	private selectedOrganisationService = inject(OrganisationSelectedService);
	private modalService = inject(ModalService);

	private offcanvasCloseSub: Subscription | null = null;
	public currentEvent: CalendarEvent<ScheduledEvent> | null = null;

	private isOwner: boolean;
	private offcanvasRef: NgbOffcanvasRef | null = null;
	private offcanvasEvent: ScheduledEventCalendarEventOffcanvas;

	showOffcanvas(event: CalendarEvent<ScheduledEvent>) {
		this.currentEvent = event;
		const accessLevel = this.selectedOrganisationService.selectedOrganisation.getValue()?.organisationUser.accessLevel;
		this.isOwner = accessLevel ? [OrganisationUserAccessLevel.OWNER, OrganisationUserAccessLevel.ADMIN].includes(accessLevel) : false;
		this.offcanvasRef = this.offcanvasService.open(CalendarOffcanvasComponent, 'end', true, 'oc-lg');
		this.offcanvasEvent = new ScheduledEventCalendarEventOffcanvas(
			this.router,
			this.calendarService,
			this.offcanvasService,
			this.leadAssessmentService,
			this.modalService,
			event,
			this.isOwner,
		);

		(this.offcanvasRef.componentInstance as CalendarOffcanvasComponent).calendarEventOffcanvas =
			this.offcanvasEvent.calendarEventOffcanvas();

		this.offcanvasCloseSub?.unsubscribe();
		this.offcanvasCloseSub = this.offcanvasRef.closed.subscribe(() => {
			this.offcanvasRef = null;
			this.currentEvent = null;
			this.offcanvasCloseSub?.unsubscribe();
			this.offcanvasCloseSub = null;
		});
	}

	updateCalendarEvent(event: CalendarEvent<ScheduledEvent>): void {
		if (!this.offcanvasRef) {
			return;
		}
		this.offcanvasEvent.event = event;
		this.currentEvent = event;
		(this.offcanvasRef.componentInstance as CalendarOffcanvasComponent).calendarEventOffcanvas =
			this.offcanvasEvent.calendarEventOffcanvas();
	}
}
